import ls from 'localstorage-slim';
import { useEffect } from 'react';
import { MetaData } from '../types/instant-lease-api';
import { getPartner } from '../utils/getter';

const useThemeHook = (definedPartner?: string, prefix?: string): void => {
  useEffect(() => {
    // Get partner
    const partner = definedPartner
      ? definedPartner.toLocaleLowerCase()
      : getPartner().toLocaleLowerCase();

    // Get theme and meta links
    const themeStyleSheet = document.getElementById('theme');
    const favicon = document.getElementById('favicon') as HTMLLinkElement;
    const metaTitle = document.getElementById('meta_title') as HTMLMetaElement;
    const metaDesc = document.getElementById('meta_desc') as HTMLMetaElement;
    const metaImage = document.getElementById('meta_image') as HTMLMetaElement;

    // Root style prevent theme flashing
    if (partner === 'lynkco') {
      document.documentElement.style.setProperty('--light-theme-bg', '#1B2021');
      document.documentElement.style.setProperty('--text-color', '#ffffff');
    } else {
      // Every page uses the Ayvens alt background (Figma: background-alt)
      document.documentElement.style.setProperty(
        '--light-theme-bg',
        'var(--ayvens-theme-background-background-alt, #F6F6F6)',
      );
      document.documentElement.style.setProperty('--text-color', '#0F3549');
    }

    const themePartner = (): string => {
      if (partner === 'smart') return 'ald_marktplatz';
      return partner;
    };

    // Hook logic — set up theme stylesheet
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.id = 'theme';
    link.href = prefix
      ? `${prefix}/theme/${themePartner()}/theme.css`
      : `/theme/${themePartner()}/theme.css`;
    ls.set('partner', themePartner().toLocaleLowerCase());

    if (!themeStyleSheet) {
      document.head.appendChild(link);
    } else if (
      themeStyleSheet.getAttribute('href') !==
      `/theme/${themePartner()}/theme.css`
    ) {
      themeStyleSheet.remove();
      document.head.appendChild(link);
    }

    if (
      favicon &&
      metaTitle &&
      metaDesc &&
      metaImage &&
      MetaData[`${themePartner}` as keyof typeof MetaData] !== undefined
    ) {
      const { icon, title, desc, thumbnail } =
        MetaData[`${themePartner}` as keyof typeof MetaData];
      favicon.href = icon;
      metaTitle.content = title;
      metaDesc.content = desc;
      metaImage.content = thumbnail;
    }
  }, [definedPartner, prefix]);
};

export default useThemeHook;
